/**
 * Admin API client — tenant CRUD (Phase 35.1, super-admin only).
 */

import { request } from "./api.js";

export const listTenants = ({ includeDeleted = false } = {}) =>
  request(
    `/api/admin/tenants${includeDeleted ? "?includeDeleted=true" : ""}`
  );

// v5.x soft-delete — flips tenants.status="deleted" without cascading
// destructive cleanup. Callers should confirm intent (typed-name modal).
export const deleteTenant = (tenantId) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}`, {
    method: "DELETE",
  });

export const getTenant = (tenantId) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}`);

export const provisionTenant = (payload) =>
  request("/api/admin/tenants", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateTenantStatus = (tenantId, status) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });

export const getTenantProvisioningStatus = (tenantId) =>
  request(
    `/api/admin/tenants/${encodeURIComponent(tenantId)}/provisioning-status`
  );

// Phase 41.7 — "Re-run bootstrap" on the tenant detail page.
export const rerunBootstrap = (tenantId, researchDomain) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}/bootstrap`, {
    method: "POST",
    body: JSON.stringify(researchDomain ? { researchDomain } : {}),
  });

// v5 Phase 49 — per-tenant budget admin API.
export const getTenantBudget = (tenantId) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}/budget`);

export const updateTenantBudget = (tenantId, payload) =>
  request(`/api/admin/tenants/${encodeURIComponent(tenantId)}/budget`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
